import { HTTPClient } from "@/utils/request.cep";

export default {
  Search: ({ payload }) => {
    return HTTPClient.post("/consultacep", {
      ...payload,
      token: "Sv6FJ6v621Tb8qJP6MkwulOSbjTf5HnTA",
    });
  },
};
